import { useEffect, useRef, useState } from 'react';

// macOS-style dock: icons magnify based on distance from the mouse cursor,
// using the same falloff shape (roughly Gaussian) as the real thing.
const BASE_SIZE = 46;
const MAX_SIZE  = 74;
const SPREAD    = 90; // px — how far the magnification effect reaches

export default function Dock({ items }) {
  const dockRef = useRef(null);
  const guscioRef = useRef(null);

  // LA BARRA PUBBLICA LA PROPRIA ALTEZZA (2026-09-10).
  //
  // Serve a due cose che prima erano a occhio: il pulsante "Install app", che
  // a 390px finiva SOPRA le icone (misurato: barra 769-830, pulsante 780-824,
  // z-index 200 contro 60), e lo spazio in fondo alla zona dei file, che
  // altrimenti scorre sotto la barra e nasconde l'ultimo file.
  // Si misura invece di scriverla: la barra cambia altezza col padding di
  // mobile, con la safe-area dell'iPhone e con la rotazione.
  useEffect(() => {
    const radice = document.documentElement;
    const nodo = guscioRef.current;
    if (!nodo) { radice.style.removeProperty('--ltc-dock-h'); return undefined; }
    const misura = () => {
      const r = nodo.getBoundingClientRect();
      // Dall'inizio della barra al fondo della finestra: comprende anche lo
      // stacco dal bordo, che e' spazio occupato quanto la barra stessa.
      radice.style.setProperty('--ltc-dock-h', Math.max(0, Math.ceil(window.innerHeight - r.top)) + 'px');
    };
    misura();
    const ro = new ResizeObserver(misura);
    ro.observe(nodo);
    window.addEventListener('resize', misura);
    window.addEventListener('orientationchange', misura);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', misura);
      window.removeEventListener('orientationchange', misura);
      radice.style.removeProperty('--ltc-dock-h');
    };
  }, []);
  const [mouseX, setMouseX] = useState(null);

  function handleMouseMove(e) {
    setMouseX(e.clientX);
  }
  function handleMouseLeave() {
    setMouseX(null);
  }

  return (
    <div className="dock-wrap" ref={guscioRef}>
      <div
        className="dock"
        ref={dockRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {items.map((item, i) => (
          <DockIcon key={item.key || i} item={item} mouseX={mouseX} dockRef={dockRef} />
        ))}
      </div>
    </div>
  );
}

function DockIcon({ item, mouseX, dockRef }) {
  const ref = useRef(null);

  let size = BASE_SIZE;
  if (mouseX != null && ref.current && dockRef.current) {
    const rect = ref.current.getBoundingClientRect();
    const center = rect.left + rect.width / 2;
    const dist = Math.abs(mouseX - center);
    const falloff = Math.max(0, 1 - dist / SPREAD);
    size = BASE_SIZE + (MAX_SIZE - BASE_SIZE) * falloff * falloff;
  }

  return (
    <button
      ref={ref}
      className={`dock-icon ${item.active ? 'dock-icon-active' : ''}${item.key ? ` dock-icon-${item.key}` : ''}`}
      style={{ width: size, height: size }}
      onClick={item.action}
      title={item.label}
      aria-label={item.label}
    >
      <span className="dock-icon-svg" style={{ width: size * 0.46, height: size * 0.46 }}>{item.icon}</span>
      {item.badge ? <span className="dock-badge">{item.badge}</span> : null}
      <span className="dock-tooltip">{item.label}</span>
      {/* L'ETICHETTA VISIBILE (2026-09-10). Le icone erano simboli muti: il
          nome esisteva solo come tooltip, che su un telefono non si apre mai.
          Stessa stringa, mostrata invece che nascosta — su schermi larghi
          resta il tooltip e questa sparisce (vedi App.css). */}
      <span className="dock-etichetta">{item.label}</span>
      {item.active && <span className="dock-dot" />}
    </button>
  );
}
